import {
  Modal as AntModal,
  Button as AntButton,
} from 'antd';
import styled from 'styled-components';
import {
  BonusModalAcceptBtnBg,
  BonusModalRejectBtnBg
} from '@assets'

export const Modal = styled(AntModal)`
  padding: 0px !important;

  .ant-modal-title {
    text-align: center;
    color: ${(props) => props.theme.primaryColor};
  }
  .ant-modal-content {
    background-image: url(${(prop) => prop.bg}) !important;
		background-size: contain !important;
		background-repeat: no-repeat !important;
		background-position: center !important;
    background-color: green;
    width: 350px;
    height: 370px;
    margin: 0 auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }

  .ant-modal-footer {
    text-align: center;
  }

  @media screen and (max-width: 370px) {
    .ant-modal-content{
      width: 300px;
      height: 350px;
    }
  }

  @media screen and (max-width: 320px) {
    .ant-modal-content{
      width: 270px;
      height: 350px;
    }
  }
`

export const Title = styled.div`
  padding: 14px 0 0 0;
  opacity: ${props => props.hide === 'true' ? 0 : 1};

  color: #FAD921;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal; 

  @media screen and (max-width: 420px) {
    padding-top: 5px;
  }

  @media screen and (max-width: 370px) {
    padding-top: 0px;
    font-size: 18px;
  }

`

export const Container = styled.div`

  position: absolute;
  top: 130px;
  left: 0%;
  margin: 18px 0;
  width: 100%;
  height: 260px;

  @media screen and (max-width: 370px) {
    top: 135px;
    height: 230px;
  }

  @media screen and (max-width: 320px) {
    height: 214px;
  }
`

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const MainText = styled.div`

  width: 68%;
  margin-top: 5px;
  padding: 0 !important;

  color: #FFF;
  text-align: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5; 
  white-space: pre-line;

  @media screen and (max-width: 370px) {
    font-size: 12px;
  }

  @media screen and (max-width: 320px) {
    font-size: 11px;
  }
`

export const Bottom = styled.div`
  position: absolute;
  bottom: -12px;
  width: 90%;
  left: 5%;
  text-align: center;

  @media screen and (max-width: 370px) {
    bottom: 5px;
  }

`;

export const Description = styled.div`
  margin-bottom: ${props => props.custom === 'true' ? '-6px' : 0};

  color: #0E1017;
  text-align: center;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal; /* 158.333% */

  @media screen and (max-width: 370px) {
    font-size: 10px;
  }

  @media screen and (max-width: 370px) {
    font-size: 9px;
  }
`

export const ButtonWrapper = styled.div`

  margin: 10px 0 0 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  gap: 10px;
  padding: 0 4px;
  
  svg{
    cursor: pointer;
  }

  @media screen and (max-width: 370px) {
    gap: 10px;
    padding: 0;
  }

`

const BasicButton = styled(AntButton)`
  font-size: 12px;
  width: 100%;
  height: 55px;

  @media screen and (max-width: 370px) {
    font-size: 10px;
    height: 45px;
  }

  @media screen and (max-width: 320px) {
    height: 40px;
  }

`

export const AcceptButtonWrapper = styled.div`
  width: 50%;
`

export const AcceptButton = styled(BasicButton)`
  background-image: url(${BonusModalAcceptBtnBg}) !important;
  background-color: transparent !important;
  background-size: cover;
  background-repeat: no-repeat;

  color: #000000 !important;
  line-height: normal;

  :hover{
    background-color: transparent !important;
    color: #000000 !important;
  }
`

export const RejectButtonWrapper = styled.div`
  width: 50%;
`

export const RejectButton = styled(BasicButton)`
  background-image: url(${BonusModalRejectBtnBg}) !important;
  background-color: transparent !important;
  background-size: cover;
  background-repeat: no-repeat;

  color: #FFF !important;

  :hover{
    background-image: url(${BonusModalRejectBtnBg}) !important;
    background-color: transparent !important;
    color: #FFF !important;
  }
`